import { useState, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { getCountries } from "../../api/AddressApi";
import { isImmutable } from "immutable";

type Props = {
  onChange: (items: any) => void;
  item: any;
  placeholder?: string;
  variant?: "default" | "inline";
  autoOpen?: boolean;
};

const CountryPicker = (props: Props) => {
  const { onChange, placeholder = "", item, variant = "default", autoOpen = false } = props;
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [menuOpen, setMenuOpen] = useState<boolean>(autoOpen);
  const isControlledMenu = !!autoOpen;

  const { data } = useQuery({
    queryKey: ["country"],
    queryFn: () => getCountries(""),
  });

  useEffect(() => {
    if (item && isImmutable(item)) {
      setSelectedOptions(item.toJS());
    }
  }, [item]);

  useEffect(() => {
    setMenuOpen(!!autoOpen);
  }, [autoOpen]);

  const inlineStyles =
    variant === "inline"
      ? {
          control: (base: any) => ({
            ...base,
            border: "1px solid rgb(209 213 219 / 1)",
            borderRadius: "6px",
            minHeight: "28px",
            padding: "0 8px",
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
          }),
          valueContainer: (base: any) => ({
            ...base,
            padding: "0",
          }),
          input: (base: any) => ({
            ...base,
            margin: "0",
            padding: "0",
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
          }),
          singleValue: (base: any) => ({
            ...base,
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
            color: "rgb(31 41 55 / 1)",
          }),
          placeholder: (base: any) => ({
            ...base,
            fontSize: "12px",
            lineHeight: "16px",
            color: "rgb(156 163 175 / 1)",
          }),
          indicatorsContainer: (base: any) => ({
            ...base,
            height: "28px",
          }),
        }
      : undefined;

  const mergedStyles = {
    ...(inlineStyles || {}),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 99999,
    }),
  };

  const menuPortalTarget = typeof document !== "undefined" ? document.body : undefined;

  return (
    <Select
      value={selectedOptions}
      classNamePrefix={placeholder}
      menuPortalTarget={menuPortalTarget}
      menuPosition="fixed"
      {...(isControlledMenu
        ? {
            menuIsOpen: menuOpen,
            onFocus: () => setMenuOpen(true),
            onMenuOpen: () => setMenuOpen(true),
            onMenuClose: () => setMenuOpen(false),
          }
        : {
            // mặc định để react-select tự quản lý; onMenuOpen để đảm bảo click vẫn mở
            onMenuOpen: () => setMenuOpen(true),
            onMenuClose: () => setMenuOpen(false),
          })}
      options={data}
      styles={mergedStyles}
      onChange={(value) => {
        setSelectedOptions(value);
        onChange(value);
      }}
    />
  );
};

export default CountryPicker;
